import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community';

interface IconCellRendererParams extends ICellRendererParams {
  icon: string;
  color: string;
  workOrderNum: string;
}

@Component({
  selector: 'app-hot-order-renderer',
  template: ` <span [style.color]="params.color">
  <i [class]="params.icon"></i>
  <span>workOrderNum</span>
  </span> `
})
export class HotOrderRendererComponent implements ICellRendererAngularComp{
  @Input() workOrderNum = '';
  public params!: IconCellRendererParams;

  agInit(params: IconCellRendererParams): void {
    this.params = params
    if (this.params.value == false || this.params.value == null) {
      this.params.icon = ''
      this.params.color = ''
    }
  }

  refresh(params: IconCellRendererParams): boolean {
    this.params = params;
    return false;
  }
}
